module.exports = __webpack_public_path__ + "assets/images/amira_initial_greeting.ee02b41266c7a002dbb5a67e037e6c55.svg";